import React from 'react';
import ReactDOM from 'react-dom';
import StockChart from './StockChart';
import './App.css';
import Header from './Header'
import AlertList from './AlertList';
import * as Actions from "./Actions"
class Main extends React.Component {
  render() {
    return (
      <div id="mainframe">
                <AlertList />
                <div id="rightpanel">
                  <Header/>
                  <StockChart/>
                </div>
      </div>
     )
  }
  componentDidMount() {
    Actions.loadSave("demo");
  }
}
export default Main;
 

